import React, { useEffect, useState } from "react";

const KPIScore = () => {
  const [kpiData, setKpiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const requestToken = localStorage.getItem("request_token");

  const getServiceNo = () => {
    const serviceNo = localStorage.getItem("serviceNo");
    return serviceNo ? serviceNo : localStorage.getItem("username");
  };

  useEffect(() => {
    const fetchData = async () => {
      const serviceNo = getServiceNo();
      const year = localStorage.getItem("year");
      const period = localStorage.getItem("period");
      const userType = localStorage.getItem("userType") || "Ex";
      let diviCode = localStorage.getItem("DivisionCode") || localStorage.getItem("DiviCode") || "";
      let depCode = localStorage.getItem("DepartmentCode") || localStorage.getItem("DepCode") || "";
      try {
        const response = await fetch(
          `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetKPIDetails?serviceNo=${serviceNo}&year=${year}&peroid=${period}&UserType=${userType}&KPI_Divition=${diviCode}&KPI_Department=${depCode}`,
          {
            headers: { request_token: requestToken },
          }
        );

        const data = await response.json();
        if (data.StatusCode === 200 && data.ResultSet) {
          const filteredData = data.ResultSet.filter(item => item.KPI_Status === "A");
          processKPIData(filteredData);
        } else {
          setKpiData(null);
        }
      } catch (error) {
        console.error("Error fetching KPI data:", error);
        setKpiData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const processKPIData = (resultSet) => {
    let divisionTotal = 0,
      departmentTotal = 0,
      selfTotal = 0,
      divisionWeight = 0,
      departmentWeight = 0,
      selfWeight = 0;
      

    resultSet.forEach((kpi) => {
      const score = parseFloat(kpi.KPI_Score) || 0;
      const weight = parseFloat(kpi.KPI_Weight) || 0;
      
      if (kpi.KPI_Criteria === "D") {
        divisionTotal += score;
        divisionWeight += weight;
      } else if (kpi.KPI_Criteria === "E") {
        departmentTotal += score;
        departmentWeight += weight;
      } else if (kpi.KPI_Criteria === "S") {
        selfTotal += score;
        selfWeight += weight;
      }
    });

    setKpiData({
      division: { score: divisionTotal, weight: divisionWeight },
      department: { score: departmentTotal, weight: departmentWeight },
      self: { score: selfTotal, weight: selfWeight },
    });
  };

  if (loading) return <p>Loading KPI data...</p>;
  if (!kpiData) return <p>No KPI data available.</p>;

  return (
    <div className="bg-white shadow p-4 rounded mb-4">
      <h3 className="text-lg font-bold text-gray-700 mb-4">KPI Score</h3>
      <table className="table-auto w-full border">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="p-2 border">KPIs</th>
            <th className="p-2 border">Scores</th>
            {/* <th className="p-2 border">Weight</th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-2 border text-left">Division KPIs</td>
            <td className="p-2 border text-left">{kpiData.division.score} ({kpiData.division.weight})</td>
            {/* <td className="p-2 border text-left">{kpiData.division.weight}</td> */}
          </tr>
          <tr>
            <td className="p-2 border text-left">Departmental KPIs</td>
            <td className="p-2 border text-left">{kpiData.department.score} ({kpiData.department.weight})</td>
            {/* <td className="p-2 border text-left">{kpiData.department.weight}</td> */}
          </tr>
          <tr>
            <td className="p-2 border text-left">Self KPIs</td>
            <td className="p-2 border text-left">{kpiData.self.score} ({kpiData.self.weight})</td>
            {/* <td className="p-2 border text-left">{kpiData.self.weight}</td> */}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default KPIScore;